export const ISSUE_LIST_TYPE = {
  TASK_LIST: 'TASK_LIST',
  ASSIGNMENT: 'ASSIGNMENT',
};
